
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'

import debounce from 'lodash/debounce'
import dayjs from 'dayjs'
// import Month from './Month'
// import schedule from '~/api/mock/event/month' // local test
// import api from '~/api/' // server

export default {
    name: 'CalendarMonth',

    props: {
        scheduleItems: Array,
        curDate: null,
    },

    data() {
        return {
            DEFAULT_DATE_FORMAT: 'YYYYMMDD',
            dayClasses: [
                'fc-sun',
                'fc-mon',
                'fc-tue',
                'fc-wed',
                'fc-thu',
                'fc-fri',
                'fc-sat',
            ],

            // weeks: [],
            now: dayjs(),
        }
    },

    computed: {
        ...mapState('main', ['cal_detail']),

        weeks() {
            let _weeks = []

            const startDate = this.curDate.clone().startOf('month')
            // console.log('startDate', startDate)
            const endDate = this.curDate.clone().endOf('month')
            // console.log('endDate', endDate)

            const weekDiff = endDate.diff(startDate, 'week')
            
            let _date = startDate.clone()

            for (let i = 0; i <= weekDiff; i++) {
                // console.log('_date', _date)
                const dates = []
                
                for (let j = 0; j < 7; j++) {
                    dates.push(_date.day(j).format(this.DEFAULT_DATE_FORMAT))
                }
                _weeks.push(dates)

                _date = _date.add(1, 'week')
            }

            /* 22.07.22 suye weeks 5주치까지만 보이고 그 뒤 일자는 짤리는 현상 처리 */ 
            const dayDiff = endDate.diff(startDate, 'day') // 마지막 일자 = (달의막일-첫일)+1
            const lastDate = _weeks[_weeks.length -1][(_weeks[_weeks.length -1]).length-1].substring(6) // _weeks배열의 마지막값

            // 월의 마지막 일자가 배열의 마지막 일자보다 클 때 + 마지막 일자는 다음 월의 초반이 아닐 때 (len으로 구분)
            if((Number(dayDiff+1) > Number(lastDate) && Number(lastDate).toString().length === 2)) {
                // console.log('came to > ')
                _weeks = []
                _date = startDate.clone()
                for (let i = 0; i <= (weekDiff+1); i++) {
                    const dates = []
                    
                    for (let j = 0; j < 7; j++) {
                        dates.push(_date.day(j).format(this.DEFAULT_DATE_FORMAT))
                    }
                    _weeks.push(dates)

                    _date = _date.add(1, 'week')
                }
            }

            console.log('_weeks', _weeks)
            return _weeks
        },
    },

    created() {
        // console.log('created this.curDate', this.curDate)
        // this.getSchedule()
        // this.getWeeks()
    },

    destroyed() {
        this.REMOVE_CALENDAR_INFO()
    },

    updated: debounce(function () {
        this.$nextTick(() => {
            console.log('cal_detail=', this.cal_detail)

            const queryId = this.cal_detail.id
            // const queryId = '780000000000306'

            if (queryId) {
                const anchor = document.createElement('a')
                anchor.href = '#' + queryId
                anchor.style.display = 'none'

                document.body.appendChild(anchor)

                anchor.click()
                this.$emit('openItem', queryId)
            }
        })
    }, 200),

    methods: {
        ...mapActions('main', ['REMOVE_CALENDAR_INFO']),

        // computed weeks 변경함
        getWeeks() {
            // monthSchedules
            // console.log('getWeeks this.schedule', this.schedule)
            // const now = dayjs('2020-09-03')
            // const now = dayjs('2020-10-03')
            // const now = dayjs()

            this.weeks = []

            const startDate = this.curDate.clone().startOf('month')
            // console.log('startDate', startDate)
            const endDate = this.curDate.clone().endOf('month')
            // console.log('endDate', endDate)

            const weekDiff = endDate.diff(startDate, 'week')

            let _date = startDate.clone()

            for (let i = 0; i <= weekDiff; i++) {
                console.log('_date', _date)
                const days = []

                for (let j = 0; j < 7; j++) {
                    days.push(_date.day(j).format(this.DEFAULT_DATE_FORMAT))
                }

                this.weeks.push(days)

                _date = _date.add(1, 'week')
            }

            console.log('this.weeks', this.weeks)
        },

        onClickPrev() {
            // this.curDate = this.curDate.subtract(1, 'month')
            // console.log('this.curDate', this.curDate)
            // this.getWeeks()

            this.$emit('clickPrev')
        },
        onClickNext() {
            // this.curDate = this.curDate.add(1, 'month')
            // console.log('this.curDate', this.curDate)
            // this.getWeeks()

            this.$emit('clickNext')
        },

        onClickOpenItem(id) {
            this.$emit('openItem', id)
        },
    },
}
